<template lang="pug">
  #Ch2IncomeSpineplot.container-fluid
    .row.d-flex.justify-content-center.align-items-center
      .col-12.desktop.mt-4.d-flex.justify-content-center
        p.d-inline-flex.px-4.py-1.mb-2.text-center.subtitle
          span ¿Cuánto gana la
          select.form-control.mx-2(v-model="generation")
            option(:value="g" v-for="g in generations") {{g}}
          span en México?
      .col-sm-12.mobile.mt-5.d-flex.justify-content-center
        p.px-4.py-2.text-center.subtitle
          span ¿Cuánto gana la
        .px-4.py-2.text-center.subtitle
          select.form-control(v-model="generation")
            option(:value="g" v-for="g in generations") {{g}}
        p.px-4.py-2.text-center.subtitle
          span en México?
      .col-12.col-lg-8.mt-1.d-flex.justify-content-center
        p.d-inline.px-4.py-2.text-center.description Por tipo de trabajo y sexo
      .col-12.mt-1
        .row.d-flex.justify-content-center.align-items-center
          .col-12.col-lg-2
            .row
              .col-12.d-flex.flex-column.justify-content-center.align-items-center
                .circle.my-1.five
                p.label No recibe ingresos
              .col-12.d-flex.flex-column.justify-content-center.align-items-center
                .circle.my-1.one
                p.label Más de 5 salarios mínimos
              .col-12.d-flex.flex-column.justify-content-center.align-items-center
                .circle.my-1.two
                p.label Más de 3 y hasta 5 salarios mínimos
              .col-12.d-flex.flex-column.justify-content-center.align-items-center
                .circle.my-1.three
                p.label Más de 1 y hasta 3 salarios mínimos
              .col-12.d-flex.flex-column.justify-content-center.align-items-center
                .circle.my-1.four
                p.label Hasta un salario mínimo
          .col-12.col-lg-8
            #spineplot.row
      .col-lg-2
      .col-10.mt-1.mb-5
        .row.d-flex.justify-content-center.align-items-center
          button.btn.col-12.col-lg-2.mx-2.my-2(@mouseover="selectOccupation('Autoempleados')", @mouseleave="unselectOccupation('Autoempleados')") Autoempleados
          button.btn.col-12.col-lg-2.mx-2.my-2(@mouseover="selectOccupation('Empleadores')", @mouseleave="unselectOccupation('Empleadores')") Empleadores
          button.btn.col-12.col-lg-2.mx-2.my-2(@mouseover="selectOccupation('Trabajadores remunerados')", @mouseleave="unselectOccupation('Trabajadores remunerados')") Trabajadores remunerados
</template>

<script>
import * as d3 from "d3";
import * as _ from "lodash";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
Exporting(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/variwide")(Highcharts);

export default {
  name: "Ch2IncomeSpineplot",
  data() {
    return {
      data: [],
      generation: "",
      generations: []
    };
  },
  watch: {
    generation() {
      this.load();
    }
  },
  methods: {
    selectOccupation(occupation) {
      d3.selectAll(".highcharts-series-group")
        .selectAll(".highcharts-point")
        .style("opacity", ".5");
      d3.selectAll(".highcharts-series-group")
        .selectAll(`.${occupation.split(" ").join("-")}`)
        .style("opacity", "1");
    },
    unselectOccupation() {
      d3.selectAll(".highcharts-series-group")
        .selectAll(".highcharts-point")
        .style("opacity", "1");
    },
    drawSpineplot(sex, series) {
      d3.select("#spineplot")
        .append("div")
        .attr("id", sex)
        .attr("class", "col-6");

      Highcharts.chart(sex, {
        chart: {
          type: "variwide",
          backgroundColor: "transparent"
        },
        title: {
          text: sex,
          style: {
            fontFamily: "Oswald",
            fontSize: "26.6px",
            fontWeight: "600",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            color: "#ffffff"
          }
        },
        subtitle: false,
        colors: ["#f7b3aa", "#ffd58a", "#78d4e1", "#34afb2", "#6a6aea"],
        xAxis: {
          type: "category",
          visible: false
        },
        yAxis: {
          visible: false
        },
        caption: false,
        legend: {
          enabled: false
        },
        plotOptions: {
          variwide: {
            stacking: "percent",
            borderColor: "#0a1d59",
            borderWidth: 5
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        series: series
      });
    },
    load() {
      d3.select("#spineplot")
        .selectAll(".col-6")
        .remove();
      _.find(this.data, { key: this.generation }).values.forEach(s => {
        const series = s.values.map(a => ({
          name: a.key,
          data: a.value,
          dataLabels: {
            enabled: false,
            format: "{point.y:.0f} %"
          },
          tooltip: {
            pointFormat:
              "Ingreso: <b>{point.series.name}, {point.y} %</b><br>" +
              "Ocupación: <b>{point.name}, {point.z} %</b><br>"
          }
          /*colorByPoint: true*/
        }));
        this.drawSpineplot(s.key, _.reverse(series));
      });
    }
  },
  async mounted() {
    const csv = await d3.csv("/assets/csv/chapter2/tipo_empleo.csv");
    const generations = d3
      .nest()
      .key(d => d.gen)
      .key(d => d.sex)
      .key(d => d.ing7c)
      .rollup(v =>
        v.map(o => ({
          name: o.pos_ocu,
          className: o.pos_ocu.split(" ").join("-"),
          y: o.per_ing === "NA" ? null : _.round(Number(o.per_ing), 2),
          z: o.per_oc === "NA" ? null : _.round(Number(o.per_oc), 2)
        }))
      )
      .entries(csv);
    this.generations = generations
      .map(g => g.key)
      .sort(
        (a, b) =>
          Number(a.split("De ")[1].substring(0, 2)) -
          Number(b.split("De ")[1].substring(0, 2))
      );
    this.generation = this.generations[0];
    this.data = generations;
    //console.log(this.data);
    this.load();
  }
};
</script>

<style lang="scss">
#Ch2IncomeSpineplot {
  //height: 100vh;
  background-color: #0a1d59;
  #spineplot {
    height: 62vh;
  }
  .subtitle {
    font-family: "Inria Sans", sans-serif;
    font-size: 41.2px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.62px;
    color: #ffffff;
    select {
      -webkit-appearance: button;
      -moz-appearance: button;
      -webkit-user-select: none;
      -moz-user-select: none;
      -webkit-padding-end: 20px;
      -moz-padding-end: 20px;
      -webkit-padding-start: 20px;
      -moz-padding-start: 20px;
      background-color: transparent; /* Fallback color if gradients are not supported */
      //background-image: url(../images/select-arrow.png), -webkit-linear-gradient(top, #E5E5E5, #F4F4F4); /* For Chrome and Safari */
      //background-image: url(../images/select-arrow.png), -moz-linear-gradient(top, #E5E5E5, #F4F4F4); /* For old Firefox (3.6 to 15) */
      //background-image: url(../images/select-arrow.png), -ms-linear-gradient(top, #E5E5E5, #F4F4F4); /* For pre-releases of Internet Explorer  10*/
      //background-image: url(../images/select-arrow.png), -o-linear-gradient(top, #E5E5E5, #F4F4F4); /* For old Opera (11.1 to 12.0) */
      //background-image: url(../images/select-arrow.png), linear-gradient(to bottom, #E5E5E5, #F4F4F4); /* Standard syntax; must be last */
      background-position: center right;
      background-repeat: no-repeat;
      border: 2px solid #ffd58a;
      border-radius: 2px;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
      color: #ffd58a;
      width: 427px;
      text-align: center;
      text-align-last: center;
      -moz-text-align-last: center;
      font-family: "Inria Sans", sans-serif;
      font-size: 25px;
      font-weight: 600;
      margin: 0;
      overflow: hidden;
      padding-top: 2px;
      padding-bottom: 2px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .description {
    font-family: "Inria Sans", sans-serif;
    font-size: 22.4px;
    font-weight: bold;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: -0.34px;
    color: #0a1d59;
    background-color: #ffffff;
  }
  .circle {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    &.one {
      background: #ffd58a;
    }
    &.two {
      background: #78d4e1;
    }
    &.three {
      background: #34afb2;
    }
    &.four {
      background: #6a6aea;
    }
    &.five {
      background: #f7b3aa;
    }
  }
  .label {
    font-family: "Inria Sans", sans-serif;
    font-size: 19.6px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    text-align: center;
  }
  button {
    width: 225px;
    height: 95px;
    border-radius: 8px;
    border: solid 2px #ffffff;
    background-color: #ff6561;
    font-family: "Inria Sans", sans-serif;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.37px;
    color: #ffffff;
    &:hover {
      background-color: #ff6561cc;
    }
  }
  .mobile {
    display: none !important;
  }
  .desktop {
    display: flex !important;
  }
}

@media (max-width: 768px) {
  #ch2section1 {
    .mobile {
      display: block !important;
      select {
        width: 100%;
        margin: 0 auto;
        max-width: 340px;
      }
    }
    .desktop {
      display: none !important;
    }
  }
}
</style>
